import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { useTranslation } from 'react-i18next';
import type { AdjustedNutrition } from '@fytness/shared';

export interface MealLogSummaryProps {
  totals: AdjustedNutrition;
}

export const MealLogSummary = ({ totals }: MealLogSummaryProps) => {
  const { t } = useTranslation('meal');

  const macros = [
    { label: t('nutrition.carbs.longLabel'), value: totals.carbs },
    { label: t('nutrition.protein.longLabel'), value: totals.protein },
    { label: t('nutrition.fats.longLabel'), value: totals.fats },
    { label: t('nutrition.fiber.longLabel'), value: totals.fiber },
  ];

  return (
    <View className="flex flex-col gap-3">
      <Text className="text-base font-sora-semibold text-text-primary">
        {t('summary.title')}
      </Text>
      <View className="rounded-xl bg-surface p-4 flex flex-col gap-3">
        <View className="flex flex-row justify-between">
          {macros.map(({ label, value }) => (
            <View key={label} className="flex flex-col items-center gap-1">
              <Text className="text-sm font-sora-semibold text-text-primary">
                {value != null ? `${Math.round(value * 10) / 10}g` : '0g'}
              </Text>
              <Text className="text-[11px] text-text-muted">{label}</Text>
            </View>
          ))}
        </View>
        <View className="flex flex-row items-center justify-center gap-2">
          <Text className="text-sm font-sora-semibold text-accent">
            {totals.calories != null
              ? `${Math.round(totals.calories)} ${t('nutrition.kcal.unit')}`
              : `0 ${t('nutrition.kcal.unit')}`}
          </Text>
        </View>
      </View>
    </View>
  );
};
